import { type ReactNode } from 'react'

import {
  ApiClientContext,
  type YogiApiClientInstance,
} from 'clients/yogi-api/api-client-context'

export function ApiClientProvider({
  client,
  children,
}: {
  client: YogiApiClientInstance
  children: ReactNode
}): JSX.Element {
  return (
    <ApiClientContext.Provider value={client}>
      {children}
    </ApiClientContext.Provider>
  )
}
